var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"text-default leading-none font-semibold text-text"},[_vm._t("default",function(){return [_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }